import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, message, Spin, theme } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { Permission, type CreateCatalogoDto, type UpdateCatalogoDto } from '@aid/shared';
import { useHasPermission } from '../../auth/useHasPermission';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { useCatalogoAdmin, useUpdateCatalogoAdmin } from './api/useCatalogosAdmin';
import { CatalogoForm } from './components/CatalogoForm';

export function CatalogoEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const catalogoId = Number(id);
  const { data: catalogo, isLoading, error } = useCatalogoAdmin(catalogoId);
  const updateCatalogo = useUpdateCatalogoAdmin();
  const hasPermission = useHasPermission(Permission.CATALOGOS_UPDATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tenés permiso para editar registros de catálogo.</div>;
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !catalogo) {
    return (
      <EmptyState
        title="Registro no encontrado"
        description="El registro que intentás editar no existe o fue eliminado."
      />
    );
  }

  const handleSubmit = async (values: CreateCatalogoDto | UpdateCatalogoDto) => {
    const { key, value, category, parent, active } = values;
    const dto: UpdateCatalogoDto = { key, value, category, parent, active };
    try {
      await updateCatalogo.mutateAsync({ id: catalogo.id, dto });
      message.success('Registro actualizado correctamente');
      navigate(`/catalogos/${catalogo.id}`);
    } catch {
      message.error('No se pudo actualizar el registro');
    }
  };

  return (
    <div>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(`/catalogos/${catalogo.id}`)}
        style={{ paddingLeft: 0, height: 'auto', marginBottom: 8 }}
      >
        Volver al registro
      </Button>
      <PageHeader title="Editar registro" subtitle={catalogo.key ?? `#${catalogo.id}`} />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <CatalogoForm
          mode="edit"
          initialValues={catalogo}
          onSubmit={handleSubmit}
          loading={updateCatalogo.isPending}
        />
      </Card>
    </div>
  );
}
